export const formatParams = (params: any) => {
  const sanitisedParams = Object.fromEntries(Object.entries(params).filter(([_, v]) => v != null));
  return sanitisedParams ? `?${new URLSearchParams(sanitisedParams as Record<string, string>).toString()}` : '';
};
